<template>
  <div class="order-ledgers-container">
    <div class="margin-top">
      <el-table :data="aOrderDetailLedgersInfo.ledgers" border style="width: 100%" v-loading="loading">
        <el-table-column prop="storeName" :label="$t('aOrderDetailLedgers.merchant')" align="center" min-width="180">
        </el-table-column>
        <el-table-column :label="$t('aOrderDetailLedgers.specification')" align="center" width="120">
          <template slot-scope="scope">
            {{ getFeeSpecName(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" :label="$t('aOrderDetailLedgers.ledgerAmount')" align="center" width="120">
        </el-table-column>
        <el-table-column :label="$t('aOrderDetailLedgers.recharge')" align="center" width="120">
          <template slot-scope="scope">
            {{ getFeeSaveTypeName(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="saveObjId" :label="$t('aOrderDetailLedgers.objectId')" align="center" width="150">
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="24" class="text-right">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getOrderLedgers } from '@/api/order/aOrderDetailApi'

export default {
  name: 'AOrderDetailLedgers',
  data() {
    return {
      aOrderDetailLedgersInfo: {
        ledgers: [],
        orderId: '',
        prodNameLike: '',
        personNameLike: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.aOrderDetailLedgersInfo.orderId = params.orderId
      this.loadOrderLedgersData()
    },
    loadOrderLedgersData() {
      this.loading = true
      const params = {
        orderId: this.aOrderDetailLedgersInfo.orderId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      getOrderLedgers(params).then(response => {
        this.aOrderDetailLedgersInfo.ledgers = response.data
        this.pagination.total = response.records
        this.loading = false
      }).catch(error => {
        console.error('获取订单分账失败:', error)
        this.loading = false
      })
    },
    getFeeSpecName(item) {
      if (item.feeSpecCd == '1001') {
        return this.$t('aOrderDetailLedgers.serviceFee')
      }
      if (item.feeSpecCd == '2002') {
        return this.$t('aOrderDetailLedgers.discount')
      }
      if (item.feeSpecCd == '3003') {
        return this.$t('aOrderDetailLedgers.productFee')
      }
      return this.$t('aOrderDetailLedgers.unknown')
    },
    getFeeSaveTypeName(item) {
      if (item.saveType == '45') {
        return this.$t('aOrderDetailLedgers.accountRecharge')
      }
      if (item.saveType == '55') {
        return this.$t('aOrderDetailLedgers.coupon')
      }
      return this.$t('aOrderDetailLedgers.unknown')
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadOrderLedgersData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadOrderLedgersData()
    }
  }
}
</script>

<style scoped>
.order-ledgers-container {
  padding: 15px;
}

.margin-top {
  margin-top: 15px;
}

.text-right {
  text-align: right;
}
</style>